import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const getOption = (value, display, symbol = '', disabled = false) => (
  <Option disabled={disabled} value={value} key={value}>
    <>
      <span className={symbol ? 'operatorSymbol' : ''}>
        {symbol}
      </span>
      {display}
    </>
  </Option>
);

const getBoolOptions = () => [getOption('True', 'True'), getOption('False', 'False')];
const getBitOptions = () => [getOption('1', 'True'), getOption('0', 'False')];

const checkNullDate = (cond, type) => ['EqualToOnlyNull', 'OnlyNotNull'].includes(cond ?? '')
&& type?.includes('date');

const nullOptions = [{
  value: 'EqualToNull',
  display: 'Exactly (blank)',
  multiple: true,
},
{
  value: 'NotNull',
  display: 'Not (blank)',
  multiple: true,
}];

const numberOptions = [
  {
    value: 'Contains',
    display: 'Contains',
  },
  {
    value: 'EqualTo',
    display: 'Exactly',
    multiple: true,
  },
  {
    value: 'EqualToOnlyNull',
    display: 'Exactly (blank)',
    multiple: true,
  },
  {
    value: 'GreaterThan',
    display: 'Greater Than',
  },
  {
    value: 'GreaterThanOrEqual',
    display: 'Greater Than or Equal',
  },
  {
    value: 'LessThan',
    display: 'Less than',
  },
  {
    value: 'LessThanOrEqual',
    display: 'Less Than or Equal',
  },
  {
    value: 'Not',
    display: 'Not',
    multiple: true,
  },
  {
    value: 'OnlyNotNull',
    display: 'Not (blank)',
    multiple: true,
  }];

const dateOptions = [
  {
    value: 'After',
    display: 'After',
  },
  {
    value: 'Before',
    display: 'Before',
  },
  {
    value: 'Between',
    display: 'Between',
    disabled: true,
  },
  {
    value: 'EqualTo',
    display: 'Exactly',
  },
  {
    value: 'EqualToOnlyNull',
    display: 'Exactly (blank)',
    multiple: true,
  },
  {
    value: 'OnlyNotNull',
    display: 'Not (blank)',
    multiple: true,
  }];

const stringOptions = [
  {
    value: 'Contains',
    display: 'Contains',
    multiple: true,
  },
  {
    value: 'EqualTo',
    display: 'Exactly',
    multiple: true,
  },
  {
    value: 'EqualToNull',
    display: 'Exactly (blank)',
    multiple: true,
  },
  {
    value: 'EndsWith',
    display: 'Ends With',
    multiple: true,
  },
  {
    value: 'NotNull',
    display: 'Not (blank)',
    multiple: true,
  },
  {
    value: 'NotContaining',
    display: 'Not Contains',
    multiple: true,
  },
  {
    value: 'StartsWith',
    display: 'Starts With',
    multiple: true,
  }];

const keywordOptions = [
  {
    value: 'ContainsAND',
    display: 'Contains(AND)',
    multiple: true,
  },
  {
    value: 'ContainsOR',
    display: 'Contains(OR)',
    multiple: true,
  },
  {
    value: 'EqualTo',
    display: 'Exactly',
    multiple: true,
  },
  {
    value: 'EqualToNull',
    display: 'Exactly (blank)',
    multiple: true,
  },
  {
    value: 'EndsWith',
    display: 'Ends With',
    multiple: true,
  },
  {
    value: 'NotNull',
    display: 'Not (blank)',
    multiple: true,
  },
  {
    value: 'StartsWith',
    display: 'Starts With',
    multiple: true,
  }];

const dropdownOptions = [
  {
    value: 'EqualTo',
    display: 'Exactly',
    multiple: true,
  },
  {
    value: 'EqualToNull',
    display: 'Exactly (blank)',
    multiple: true,
  },
  {
    value: 'Not',
    display: 'Not',
    multiple: true,
  },
  {
    value: 'NotNull',
    display: 'Not (blank)',
    multiple: true,
  }
];

const boolOptions = [{
  value: 'EqualTo',
  display: 'Exactly',
}];

const postptDueOptions = [
  {
    value: 'EqualTo',
    display: 'Exactly',
    multiple: true,
  },
  {
    value: 'EqualToNull',
    display: 'Exactly (blank)',
    multiple: true,
  },
  {
    value: 'Not',
    display: 'Not',
    multiple: true,
  },
  {
    value: 'NotNull',
    display: 'Not (blank)',
    multiple: true,
  }
];

const getTypeOptionArray = (type) => {
  switch (type) {
    case 'bit':
      return boolOptions;
    case 'date':
    case 'datetime':
    case 'datetime2':
      return dateOptions;
    case 'bigint':
    case 'int':
    case 'decimal':
    case 'float':
      return numberOptions;
    case 'nvarchar':
    case 'varchar':
    case 'string':
      return stringOptions;
    default:
      return [];
  }
};

const BLANK_VALUE = '(Blank)';

export {
  getOption,
  getBoolOptions,
  getBitOptions,
  numberOptions,
  dateOptions,
  stringOptions,
  dropdownOptions,
  boolOptions,
  postptDueOptions,
  nullOptions,
  keywordOptions,
  getTypeOptionArray,
  BLANK_VALUE,
  checkNullDate,
};
